import React, { useState, useContext } from "react";
import Select from "react-select";
import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";

import "./index.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoMdAddCircleOutline } from "react-icons/io";
import { ConfiguracaoGlebaContext } from "../../../../../../contexts/ConfiguracaoGlebaContext";
import { getProdutoFungicida } from "../../../../../../Services/programation.service";

const options = [
  { value: "Produtor1", label: "Produtor1" },
  { value: "Produtor2", label: "Produtor2" },
  { value: "Produtor3", label: "Produtor3" },
];
function Fungicidas() {
  const { configuracaoGleba, setConfiguracaoGleba, activeCulturaIndex, setProgramacaoAlterada } = useContext(
    ConfiguracaoGlebaContext
  );

  const handleAddRow = () => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              fungicida: [
                ...(cultura?.fungicida ? cultura.fungicida : []),
                {
                  id: Date.now(),
                  produtoFungicidaId: "",
                  quantidade: null,
                  similar: false,
                },
              ],
            }
          : cultura
      ),
    }));
  };

  const handleRemoveRow = (idToRemove) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              fungicida: (cultura.fungicida || []).filter(
                (item) => item.id !== idToRemove
              ),
            }
          : cultura
      ),
    }));
  };

  const handleMoveRow = (index, direction) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) => {
        if (i !== activeCulturaIndex) return cultura;
        const lista = [...(cultura.fungicida || [])];
        const novoIndex = index + direction;
        if (novoIndex < 0 || novoIndex >= lista.length) return cultura;
        [lista[index], lista[novoIndex]] = [lista[novoIndex], lista[index]];
        return { ...cultura, fungicida: lista };
      }),
    }));
  };

  const FungicidaConfigurationFetch = async () => {
    const {
      res: { data: produtoFungicidaData },
    } = await getProdutoFungicida();

    return {
      produtoFungicida: produtoFungicidaData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      similar: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    };
  };
  const configOptionsQueryFuncida = useQuery(
    ["configOptionsQueryFungicida"],
    FungicidaConfigurationFetch,
    {
      produtoFungicida: [],

      similar: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    }
  );
  // Atualiza SEM mutar o estado (mutação direta corrompe o prevState de
  // outras atualizações no mesmo lote e quebra comparações do React).
  const atualizarLinha = (name, index, value) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: (prevState.culturas || []).map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              fungicida: (cultura.fungicida || []).map((item, j) =>
                j === index ? { ...item, [name]: value } : item
              ),
            }
          : cultura
      ),
    }));
  };

  const handleSelectChange = (name, index) => {
    return (option) => {
      atualizarLinha(name, index, option.value);
      if (name === "produtoFungicidaId") {
        // Mantém o objeto aninhado usado pelo Select controlado (label)
        atualizarLinha("produtoFungicida", index, {
          id: option.value,
          nome: option.label,
        });
      }
    };
  };

  const handleInputChange = (name, index) => {
    return (e) => atualizarLinha(name, index, e.target.value);
  };

  return (
    <div className="table-responsive">
      <div className="title-card">FUNGICIDAS</div>
      {configuracaoGleba.culturas.length !== 0 ? (
        <>
        <table className="table">
          <tbody style={{ width: "100%", marginBottom: "0px" }}>
            {(configuracaoGleba?.culturas?.[activeCulturaIndex]?.fungicida || []).map(
              (rowData, index) => (
                <tr
                  style={{
                    display: "flex",
                    width: "max-content",
                    boxShadow: "0px -4px 12px -1px rgba(0,0,0,0.45)",
                    margin: "10px",
                    // border: "solid 2px #dfdfdf",
                    borderRadius: "6px",
                    padding: "5px",
                    background: "rgba(1, 104, 32, 0.1)",
                  }}
                  key={rowData.id}
                >
                  <th
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      padding: "0 4px",
                    }}
                  >
                    <button
                      type="button"
                      className="button-move"
                      disabled={index === 0}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity: index === 0 ? 0.25 : 1,
                      }}
                      onClick={() => handleMoveRow(index, -1)}
                      title="Subir"
                    >
                      ▲
                    </button>
                    <button
                      type="button"
                      className="button-move"
                      disabled={
                        index ===
                        (configuracaoGleba?.culturas?.[activeCulturaIndex]
                          ?.fungicida?.length || 0) - 1
                      }
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity:
                          index ===
                          (configuracaoGleba?.culturas?.[activeCulturaIndex]
                            ?.fungicida?.length || 0) - 1
                            ? 0.25
                            : 1,
                      }}
                      onClick={() => handleMoveRow(index, 1)}
                      title="Descer"
                    >
                      ▼
                    </button>
                  </th>
                  <div className="column-configs-table">
                    <th className="correct-inline">Produto</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        value={{
                          label: rowData?.produtoFungicida?.nome,
                          value: rowData?.produtoFungicida?.id,
                        }}
                        onChange={handleSelectChange(
                          "produtoFungicidaId",
                          index
                        )}
                        // onChange={setSelectedOption}
                        options={
                          configOptionsQueryFuncida?.data?.produtoFungicida
                        }
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Quantidade/ha (l ou Kg)</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="number"
                        value={rowData?.quantidade ?? ""}
                        onChange={handleInputChange("quantidade", index)}
                      />
                    </td>
                  </div>
                  {/* <div className="column-configs-table">
                  <th className="correct-inline">Área</th>
                  <td>
                    <input
                      className="input-atributo"
                      type="text"
                      value={rowData.coluna3}
                      onChange={(e) => handleChange(e, index, "coluna3")}
                    />
                  </td>
                </div> */}
                  <div className="column-configs-table">
                    <th className="correct-inline">Área</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="number"
                        value={
                          rowData.area
                            ? rowData.area
                            : configuracaoGleba.culturas[activeCulturaIndex]
                                ?.area || ""
                        }
                        onChange={handleInputChange("area", index)}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Similar</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        defaultValue={{
                          label: rowData.similar ? "Sim" : "Não",
                          value: rowData.similar,
                        }}
                        onChange={handleSelectChange("similar", index)}
                        options={configOptionsQueryFuncida?.data?.similar}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline coluna-total">
                      Quantidade Total (l ou Kg)
                    </th>
                    <td>
                      <input
                        style={{
                          background: "rgba(1, 104, 32, 0.1)",
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                          textAlign: "center",
                        }}
                        disabled="true"
                        className="input-atributo"
                        type="number"
                        value={parseFloat(
                          rowData?.area * rowData?.quantidade ||
                            (configuracaoGleba.culturas[activeCulturaIndex]
                              ?.area || 0) * rowData?.quantidade ||
                            0
                        ).toFixed(2)}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Estádio</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="text"
                        value={rowData?.estadio}
                        onChange={handleInputChange("estadio", index, "text")}
                      />
                    </td>
                  </div>
                  <th>
                    <button
                      className="button-remove"
                      variant="danger"
                      onClick={() => handleRemoveRow(rowData.id)}
                    >
                      <RiDeleteBin6Line />
                    </button>
                  </th>
                </tr>
              )
            )}
          </tbody>
        </table>
        {/* Botão FORA da <table>: <button> filho direto de <tbody> é HTML inválido */}
        <button
          className="button-add"
          variant="danger"
          onClick={() => handleAddRow()}
        >
          <IoMdAddCircleOutline />
        </button>
        </>
      ) : (
        <>
          <div className="no-data-info">Você não possui dados cadastrados.</div>
          <Button
            className="button-add1"
            variant="danger"
            onClick={() => handleAddRow()}
          >
            <IoMdAddCircleOutline />
          </Button>
        </>
      )}
    </div>
  );
}

export default Fungicidas;
